import React from "react";

const CLOCK = `${import.meta.env.BASE_URL}img/worli/clock.png`;

/**
 * Matka (worli3) market tabs in the reference markup:
 *   .matka-tabs > ul.nav.nav-pills > li.nav-item.pointer > a.nav-link[.active]
 *     (market name, .remaining-time > img + span ptime, .game-time > span mtime)
 * markets = the worli3 feed (array of { mid, mname, ptime, mtime }). Styled by index.css (.matka .matka-tabs).
 */
export default function MatkaTabs({ markets = [], activeIndex = 0, onSelect }) {
  return (
    <div className="matka-tabs">
      <ul className="nav nav-pills">
        {markets.map((m, i) => (
          <li key={m.mid ?? i} className="nav-item pointer">
            <a className={i === activeIndex ? "nav-link active" : "nav-link"} onClick={() => onSelect?.(i, m)}>
              {`\n                  ${m.mname ?? ""}\n                  `}
              <div className="remaining-time">
                <img src={CLOCK} alt="" /> <span>{m.ptime}</span>
              </div>{" "}
              <div className="game-time">
                <span>{m.mtime}</span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
